export const ICON_COLOR_MAP = {
    black: 'nucleus-text-neutral-900',
    blue: 'nucleus-text-blue-500',
    current: 'nucleus-text-current',
    gray: 'nucleus-text-neutral-450',
    grayDark: 'nucleus-text-neutral-600',
    grayLight: 'nucleus-text-neutral-400',
    grayPale: 'nucleus-text-neutral-300',
    primary: 'nucleus-text-primary-500',
    white: 'nucleus-text-white',
    green: 'nucleus-text-green-500',
    greenPale: 'nucleus-text-green-200',
    red: 'nucleus-text-red-500',
    redPale: 'nucleus-text-red-200',
    yellow: 'nucleus-text-yellow-500',
    yellowLight: 'nucleus-text-yellow-400',
    yellowPale: 'nucleus-text-yellow-200',
    yellowDark: 'nucleus-text-yellow-600',
    orange: 'nucleus-text-orange-300',
    orangeLight: 'nucleus-text-orange-400',
    orangePale: 'nucleus-text-orange-200',
};
export const ICON_SIZES_MAP = {
    xs: 'nucleus-w-3 nucleus-h-3',
    sm: 'nucleus-w-4 nucleus-h-4',
    base: 'nucleus-w-6 nucleus-h-6',
    full: 'nucleus-w-full nucleus-h-full',
};
//# sourceMappingURL=icon.types.js.map